import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-900 text-background-50">
      {/* Upper Footer */}
      <div className="px-4 md:px-6 lg:px-10 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="font-heading text-xl font-bold text-background-50">
              Kakobuy <span className="text-accent-400">Finds</span>
            </Link>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed max-w-xs">
              {t('site_tagline')}
            </p>
            <p className="mt-4 text-xs text-foreground-400">
              {t('footer_disclaimer_text')}
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-semibold text-sm text-background-50 mb-4 pb-2 border-b border-foreground-700">
              {t('footer_categories')}
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More Categories */}
          <div>
            <h4 className="font-semibold text-sm text-background-50 mb-4 pb-2 border-b border-foreground-700">
              {t('footer_links')}
            </h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Article & Safety */}
          <div>
            <h4 className="font-semibold text-sm text-background-50 mb-4 pb-2 border-b border-foreground-700">
              {t('nav_articles')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/artykul-kakobuy-poradnik"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                >
                  Kakobuy Spreadsheet – Poradnik
                </Link>
              </li>
              <li>
                <Link
                  to="/cssbuy-spreadsheet"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                >
                  CSSBuy Spreadsheet
                </Link>
              </li>
              <li>
                <Link
                  to="/superbuy-spreadsheet"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                >
                  Superbuy Spreadsheet
                </Link>
              </li>
              <li>
                <Link
                  to="/oopbuy-spreadsheet"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                >
                  Oopbuy Spreadsheet
                </Link>
              </li>
              <li className="pt-2 border-t border-foreground-700/30">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-accent-400 hover:text-accent-300 transition-colors font-medium"
                >
                  Kakobuy Sheet <i className="ri-arrow-right-up-line text-xs ml-0.5"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-700/50 px-4 md:px-6 lg:px-10 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            {t('footer_copyright')}
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="text-xs text-foreground-400 hover:text-background-50 transition-colors"
            >
              {t('nav_home')}
            </Link>
            <Link
              to="/artykul-kakobuy-poradnik"
              className="text-xs text-foreground-400 hover:text-background-50 transition-colors"
            >
              {t('nav_articles')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}